module.exports = __webpack_public_path__ + "img/Skirt-Front-B6-Db-Ga-Ha-Ia-inside.9c8004b3.png";